import { isRouteErrorResponse, Link, useRouteError } from 'react-router';
export function RouteErrorPage() {
  const err = useRouteError();
  const message = isRouteErrorResponse(err) ? `${err.status} ${err.statusText}` : err instanceof Error ? err.message : 'Unknown error';
  return (
    <div className="empty-state" style={{ marginTop: 80 }}>
      <div className="page-title">Something went wrong</div>
      <p style={{ color: 'var(--text-secondary)' }}>{message}</p>
      <Link className="btn btn-primary btn-sm" to="/">Back to dashboard</Link>
    </div>
  );
}
